import { datadogRum } from '@datadog/browser-rum';

export const initDataDog = () => {
    datadogRum.init({
        applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID || '',
        clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN || '',
        site: 'datadoghq.eu',
        service: import.meta.env.VITE_DATADOG_SERVICE_NAME,
        env: import.meta.env.VITE_BRANCH === 'master' ? 'prod' : 'stg',
        version: import.meta.env.VITE_TT_VERSION,
        sampleRate: 100,
        premiumSampleRate: 0,
        trackInteractions: false,
        trackResources: true,
    });
    datadogRum.setGlobalContextProperty('fxt.service.id', 'tt');
};

export const addDataDogError = (error: Error) => {
    datadogRum.addError(error);
};

export const reportPreferredCityPairsSelectionMethod = (selectionMethod: 'CitiesFilter' | 'CSVUpload') => {
    datadogRum.addAction('preferredCityPairsSelectionMethod', {
        selectionMethod: selectionMethod,
    });
};

export const reportTurboTouchRuleSubmitted = (isEditing = false) => {
    if (isEditing) {
        datadogRum.addAction('turboTouchRuleEdited');
    } else {
        datadogRum.addAction('turboTouchRuleCreated');
    }
};
